import React from 'react'
import './Breadcrumbdata.css'
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const Breadcrumbdata = ({ data }) => {
    return (
        <>
            <div className="Breadcrumb_comp">
                <Breadcrumb>
                    {data?.map((item, index) => (
                        <Breadcrumb.Item
                            key={index}
                            href={item.link}
                            active={index === data.length - 1}
                        >
                            {item.label} {index !== data.length - 1 && <span className="breadcrumb-dot"> <FontAwesomeIcon icon={faChevronRight} /> </span>}
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            </div>
        </>
    )
}

export default Breadcrumbdata